import type {
  AvailabilityValidationResult,
  SingleAvailabilityValidationResult,
  LotteryAvailabilityValidationResult,
  AvailabilityValidationErrorType,
  AvailabilityValidationErrorReason,
  NotAvailableAvailabilityValidationErrorReason,
  OutOfStockAvailabilityValidationErrorReason,
  PriceNotUpdatedAvailabilityValidationErrorReason,
  ExceedingSellingNumLimitAvailabilityValidationErrorReason,
  SpecifiedDeliveryTime
} from "@/types/order";

export const isNotAvailableAvailabilityValidationErrorReason = (
  reason: AvailabilityValidationErrorReason
): reason is NotAvailableAvailabilityValidationErrorReason =>
  reason.errorType === "NOT_AVAILABLE";
export const isOutOfStockAvailabilityValidationErrorReason = (
  reason: AvailabilityValidationErrorReason
): reason is OutOfStockAvailabilityValidationErrorReason =>
  reason.errorType === "OUT_OF_STOCK";
export const isPriceNotUpdatedAvailabilityValidationErrorReason = (
  reason: AvailabilityValidationErrorReason
): reason is PriceNotUpdatedAvailabilityValidationErrorReason =>
  reason.errorType === "PRICE_NOT_UPDATED";
export const isExceedingSellingNumLimitAvailabilityValidationErrorReason = (
  reason: AvailabilityValidationErrorReason
): reason is ExceedingSellingNumLimitAvailabilityValidationErrorReason =>
  reason.errorType === "EXCEEDING_SELLING_NUM_LIMIT";

export const isSingleAvailabilityValidationResult = (
  result: AvailabilityValidationResult
): result is SingleAvailabilityValidationResult =>
  result.productType === "single";

export const isLotteryAvailabilityValidationResult = (
  result: AvailabilityValidationResult
): result is LotteryAvailabilityValidationResult =>
  result.productType === "lottery";

export const sortAvailabilityValidationErrorType = <
  T extends AvailabilityValidationErrorReason
>(
  reasons: T[]
) => {
  const errorTypeOrder: { [key in AvailabilityValidationErrorType]: number } = {
    PRICE_NOT_UPDATED: 1,
    NOT_AVAILABLE: 2,
    OUT_OF_STOCK: 3,
    EXCEEDING_SELLING_NUM_LIMIT: 4,
  };

  return [...reasons].sort(
    (a, b) => errorTypeOrder[a.errorType] - errorTypeOrder[b.errorType]
  );
};

export const toSpecifiedDeliveryTimeStr = (specifiedDeliveryTime: SpecifiedDeliveryTime) => {
  switch (specifiedDeliveryTime) {
    case '0800_1200':
      return '午前中'
    case '1400_1600':
      return '14〜16時'
    case '1600_1800':
      return '16〜18時'
    case '1800_2000':
      return '18〜20時'
    case '1900_2100':
      return '19〜21時'
    default:
      return '指定なし'
  }
}